import { Box, Stack, Typography } from '@mui/material';

import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';

import { TypeaheadSelectInputOption } from './inputTypes';

type TypeaheadOptionEndContentProps = Pick<
  TypeaheadSelectInputOption<unknown>,
  'badgeText' | 'badgeVariant' | 'endAdornment' | 'endLabel'
> & {
  endLabelLayout?: 'inline' | 'stacked';
  showEndLabel?: boolean;
};

export function TypeaheadOptionEndContent({
  badgeText,
  badgeVariant = BadgeVariants.SecondaryFilled,
  endAdornment,
  endLabel,
  endLabelLayout = 'inline',
  showEndLabel = true,
}: TypeaheadOptionEndContentProps) {
  const endLabelContent = showEndLabel && endLabel && (
    <Typography variant="body-xs">{endLabel}</Typography>
  );
  const badgeContent = badgeText && (
    <Badge variant={badgeVariant} display={badgeText} />
  );

  if (endLabelLayout === 'stacked') {
    return (
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Stack spacing={2}>
          {endLabelContent}
          {badgeContent}
        </Stack>
        {endAdornment && (
          <Box display="flex" lineHeight={0}>
            {endAdornment}
          </Box>
        )}
      </Stack>
    );
  }

  return (
    <Stack spacing={2} direction="row" alignItems="center">
      {endLabelContent}
      {(badgeContent || endAdornment) && (
        <Stack spacing={0.5} direction="row" alignItems="center">
          {badgeContent}
          {endAdornment && (
            <Box display="flex" lineHeight={0}>
              {endAdornment}
            </Box>
          )}
        </Stack>
      )}
    </Stack>
  );
}
